module.exports = __webpack_public_path__ + "assets_1781767203318/img/pic.cd38b695.png";